/*
 * @author Igor Serpak <robobee>
 */
const employeeShiftCancellationStatus = function() {

  const NEW = 1;
  const APPROVED = 2;
  const REJECTED = 3;

  const names = {};
  names[NEW] = 'New';
  names[APPROVED] = 'APPROVED';
  names[REJECTED] = 'REJECTED';

  return {
    getNames() {
      return names;
    },

    isNew(status) {
      return status === NEW;
    },

    isApproved(status) {
      return status === APPROVED;
    },

    isRejected(status) {
      return status === REJECTED;
    }
  };
};

angular.module('data.employee').service('employeeShiftCancellationStatus', employeeShiftCancellationStatus);
